module.exports = __webpack_public_path__ + "static/media/thumb4.693f4239.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/thumb4.jpg
// module id = 643
// module chunks = 0